import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { Pencil } from "../../../../../styles/icons/pencil";

import type { CustomHeader } from "../../server/supabase-custom-email-header-service";
import type { FC } from "react";

export const EditHeaderButton: FC<{
  customHeader: CustomHeader;
  onClick: () => void;
}> = ({ customHeader, onClick }) => (
  <GridActionsCellItem
    key="edit"
    icon={
      <Tooltip title={`Edit "${customHeader.display_name}"`} placement="right">
        <Pencil fontSize="small" />
      </Tooltip>
    }
    label={`Edit "${customHeader.display_name}"`}
    aria-label={`Edit "${customHeader.display_name}"`}
    onClick={onClick}
    showInMenu={false}
  />
);
